import React, { useEffect, useState } from "react"
import { Button, DatePicker, Drawer, Input, Layout, message, Select, Space, Table } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import type { ColumnsType } from "antd/es/table"
import { useDispatch, useSelector } from "react-redux"
import ActivitySignInfo from "./ActivitySignInfo"

const { Search } = Input
const { RangePicker } = DatePicker

/**
 * 定义ActivitySignType
 * @constructor
 */
interface ActivitySignType {
    id: number
    activityId: number
    activityName: string
    userId: number
    name: string
    telephone: string
    province: string
    company: string
    position: string
    idNumber: string
    created: string
    modified: string
}

const ActivitySignTable: React.FC = () => {
    const [infoOpen, setInfoOpen] = useState(false)
    const [currentSignNo, setCurrentSignNo] = useState("")

    const activitySign = useSelector((state: any) => state.activitySign)
    const dispatch = useDispatch()

    const [messageApi, contextMessageHolder] = message.useMessage()

    const columns: ColumnsType<ActivitySignType> = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "活动名称",
            dataIndex: "activityName",
            key: "activityName",
        },
        {
            title: "姓名",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "手机号码",
            dataIndex: "telephone",
            key: "telephone",
        },
        {
            title: "省份",
            dataIndex: "province",
            key: "province",
        },
        {
            title: "公司",
            dataIndex: "company",
            key: "company",
        },
        {
            title: "职位",
            dataIndex: "position",
            key: "position",
        },
        {
            title: "身份证号",
            dataIndex: "idNumber",
            key: "idNumber",
        },
        {
            title: "报名时间",
            dataIndex: "created",
            key: "created",
        },
        {
            title: "操作",
            key: "action",
            render: (_, record) => {
                return (
                    <>
                        <Button type="link" size={"small"} onClick={() => handleInfo(record)}>
                            查看详情
                        </Button>
                    </>
                )
            },
        },
    ]

    const onSearch = (value: string) => {
        let request = activitySign.request
        request.keyword = value
        request.pageNum = 1
        dispatch.activitySign.setData({ request })
    }

    const handleInfo = (record: ActivitySignType) => {
        setCurrentSignNo(record.id.toString())
        setInfoOpen(true)
    }

    const onInfoClose = () => {
        setInfoOpen(false)
        setCurrentSignNo("")
    }

    const setDateRange = (dates: any) => {
        let request = activitySign.request
        if (dates && dates.length === 2) {
            request.start = dates[0].format('YYYY-MM-DD')
            request.end = dates[1].format('YYYY-MM-DD')
        } else {
            request.start = ""
            request.end = ""
        }
        request.pageNum = 1
        dispatch.activitySign.setData({ request })
    }

    const setActivity = (activityId: string) => {
        let request = activitySign.request
        request.activityId = activityId
        request.pageNum = 1
        dispatch.activitySign.setData({ request })
    }

    const handleDownload = async () => {
        try {
            await dispatch.activitySign.download()
            messageApi.success("下载成功")
        } catch (error) {
            console.error('Download error:', error)
            messageApi.error("下载失败")
        }
    }

    const activity = useSelector((state: any) => state.activity)

    const activityOptions = [
        { label: "全部", value: "" },
        ...activity.list.map((item: any) => ({
            label: item.name,
            value: item.id
        }))
    ]

    useEffect(() => {
        dispatch.activity.list()
    }, [dispatch.activity])

    useEffect(() => {
        dispatch.activitySign.page()
    }, [activitySign.request.keyword, activitySign.request.pageNum, activitySign.request.activityId, activitySign.request.start, activitySign.request.end, dispatch.activitySign])

    return (
        <>
            {contextMessageHolder}
            <Layout>
                <Space>
                    <Select style={{ width: 350 }} onChange={(activityId: string) => setActivity(activityId)} options={activityOptions} placeholder="选择活动" />
                    <RangePicker onChange={setDateRange} placeholder={['开始日期', '结束日期']} />
                    <Search placeholder="输入查询内容" enterButton="查询" onSearch={onSearch} />
                    <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
                        下载
                    </Button>
                </Space>
                <Layout style={{ marginTop: "10px" }}>
                    <Table
                        columns={columns}
                        dataSource={activitySign.data.list}
                        pagination={{
                            pageSize: activitySign.data.pageSize,
                            total: activitySign.data.total,
                            onChange: (page, pageSize) => {
                                let request = { ...activitySign.request, pageNum: page, pageSize }
                                dispatch.activitySign.setData({ request })
                            },
                        }}
                    />
                </Layout>
            </Layout>

            <Drawer
                title="活动报名详情"
                width={500}
                open={infoOpen}
                onClose={onInfoClose}
                styles={{ body: { paddingBottom: 80 } }}
            >
                {currentSignNo && (
                    <ActivitySignInfo
                        signNo={currentSignNo}
                        onClose={onInfoClose}
                        onStatusChange={() => {
                            messageApi.success("状态更新成功")
                            dispatch.activitySign.page()
                        }}
                    />
                )}
            </Drawer>
        </>
    )
}

export default ActivitySignTable